import click from 'assets/images/click.png'
import illustation from 'assets/images/illustation.png'
import swap from 'assets/images/swap.png'
import { TextParagraph } from 'theme/components/text'

const features = [
  {
    icon: swap,
    title: 'Swapping made simple',
    description: 'Trade crypto effortlessly. Swap Worldcoin and other assets directly from your World App.',
  },
  {
    icon: click,
    title: 'One click, best trade',
    description: 'Get optimal swaps every time. Our routing finds the best rates, then one-click.',
  },
  {
    icon: illustation,
    title: 'Low transaction fee',
    description: 'Maximize value, minimize cost. Enjoy affordable, efficient swaps in World App.',
  },
]

export function FeatureSection() {
  return (
    <section className="w-full px-5 xl:px-[160px] 2xl:px-[220px] mx-auto pt-20 lg:pt-[100px] pb-[40px] lg:pb-[100px]">
      <div className="flex flex-col lg:flex-row items-start justify-between mb-[60px]">
        <TextParagraph size="sm" className="whitespace-nowrap mb-3">
          WORLD SWAP
        </TextParagraph>

        <div className="max-w-[611px] flex flex-col gap-4">
          <TextParagraph size="big" variant="black">
            WorldSwap offers unified and efficient access to liquidity across the WorldChain ecosystem.
          </TextParagraph>

          <TextParagraph size="lg">
            Designed as a decentralized exchange and aggregator, WorldSwap enables seamless token swaps by routing
            through the most optimal liquidity sources on WorldChain. It empowers users with secure, fast, and
            cost-effective trading—whether from native pools or integrated protocols.
          </TextParagraph>
        </div>
      </div>

      <div>
        {features.map(({ icon, title, description }) => (
          <div key={title}>
            <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 py-4">
              <div className="flex items-center gap-3">
                <div className="h-12 w-20 flex items-center justify-center">
                  <img src={icon} alt="illustration" className="h-full" />
                </div>

                <TextParagraph size="xl" variant="light10">
                  {title}
                </TextParagraph>
              </div>

              <TextParagraph size="sm" variant="light8">
                {description}
              </TextParagraph>
            </div>

            <div className="w-full h-[1px] bg-[#D1D4DC] my-2.5" />
          </div>
        ))}
      </div>
    </section>
  )
}
